export class AppEnv {
  static STAR_GAZER_API = 'https://www.stargazer.network/api/v1';
  static DAG_EXPLORER_API = 'https://www.dagexplorer.io/api/v1';
  static DAG_EXPLORER_REST = 'https://dag-explorer.firebaseio.com/app';
  static DAG_PRICE_API =
    'https://api.coingecko.com/api/v3/simple/price?ids=constellation-labs&vs_currencies=';
  static DAG_BLOCK_EXPLORER_API =
    'https://block-explorer.constellationnetwork.io/transaction/';

  static FIREBASE_CONFIG = {
    apiKey: 'AIzaSyCss80gAltjQlksPtWj0uBM7xty3QLWISs',
    authDomain: 'dag-explorer.firebaseapp.com',
    databaseURL: 'https://dag-explorer.firebaseio.com',
    projectId: 'dag-explorer',
    appId: '1:711089643389:web:3d7ec4bcd8cf2244fb7614'
  };
}
